import { DataTypeColumn } from '../../Common/commonColumnHelpers'
import { ConvenienceChain } from 'models/google_place_chain'
import {
  getGooglePlaceDoorBaseColumns,
  GooglePlaceDoorBaseWithProxyFields,
} from '../GooglePlaceBase/GooglePlaceDoorsBaseColumnsInfo'

export const CONVENIENCE_DOORS_COLUMNS =
  getGooglePlaceDoorBaseColumns('Convenience')

export const _typeCheck: Record<
  keyof GooglePlaceDoorBaseWithProxyFields & ConvenienceChain,
  DataTypeColumn
> = CONVENIENCE_DOORS_COLUMNS
